
import {map, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { ApplicationService } from 'app/services/application.service';
import { PopupService } from '../../../services/shared/popup.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PermitService } from 'app/services/permit.service';
import { VehicleService } from 'app/services/vehicle.service';
import { PlaceService } from 'app/services/place.service';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Observable } from 'rxjs';
import { AuthWebService } from 'app/services/authweb.service';
import { RouteService } from 'app/services/route.service';
import { CountryService } from 'app/services/country.service';
import { TransportAssocService } from 'app/services/transport-assoc.service';
import { CarrierService } from 'app/services/carrier.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';


@Component({
  selector: 'app-modify-route',
  templateUrl: './modify-route.component.html',
  styleUrls: ['./modify-route.component.css'],
  providers:[PlaceService,RouteService]
})
export class ModifyRouteComponent implements OnInit {

  @Input() dataCntrl: any;

  form: FormGroup;
  model : any = [];
  tabload:boolean=false;
  public pageload = false;
  disableBtn : boolean = false;
  selectedStartCoutry:any;

  @ViewChild('instance') instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  places: any = [];
  routes: any = [];
  ownRoutes: any = [];
  countries: any = [];
  selectedRadio:boolean = false;
  route_detail:any;
  start:any;
  end:any;
defaultValue:string = '';
selectedRoute:any;
placeSelected: any = [];
btnRadio:any;
selectedEndCoutry: any;
placeEndSelected: any = [];
defaultStartCoutry:any;
defaultEndCoutry:any;

selectedEndPlace:any;
selectedStartPlace:any;
defaultStartPlace:any;
defaultEndPlace:any;

default:any;

isCheck: boolean = true;
checkDelete: boolean = true;
isDupApplication: boolean = false;
tranportAssociation : any;
frghtPass = '';
quillConfig={
  //toolbar: '.toolbar',
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      //['code-block'],
      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      //[ 'header'],


      ['clean'],                                         // remove formatting button

      ['link'],
      ['link', 'image', 'video']  
    ],
    
  }
  
}

  constructor(private formBuilder: FormBuilder,private toastr: ToastrService,private toastService:ToastNotificationService,
    private showModal:PopupService,public applicationService: ApplicationService,
    private router:Router,private permitService:PermitService,
    private vehicleService:VehicleService,private authWebService: AuthWebService,
    private activeRoute: ActivatedRoute,private placeService: PlaceService,
    private documenttypeService:DocumenttypeService,
    private routeService:RouteService,
    private countryService:CountryService,
    private transportAssocService: TransportAssocService,
    private carrierService:CarrierService) {

  }

  ngOnInit() {
    
    this.frghtPass = this.dataCntrl.permit_type.freight_passenger_ind == 1 ? 'A' : 'B';

    if(this.router.url.indexOf('edit') > 0){
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.id=  params['id'];
        if(environment.authWebApi.userData.Roles.find(p=>p.Code=='ADMIN')){
          this.disableBtn = true;
          //console.log('This is Admin')
        }
      });
    }    
    this.initForm();
    //this.getPlaces();
    
    this.getCustomRoute();
    this.model = this.dataCntrl;
    // this.model.application.route_summary = 'My Route';
    // this.route_detail = 'My Route';
    //console.log(this.dataCntrl)
    //console.log(this.dataCntrl.route_id);
    //console.log(this.dataCntrl);
    this.isDupApplication = this.dataCntrl.permit_type.code == this.authWebService.userData.Configurations.find(x => x.Code == "DupPermitAppCode1").Value;
    //console.log(this.isDupApplication);
    this.getTransportAssociation();
  }

  getTransportAssociation()
  {
       this.carrierService.getById(this.dataCntrl.carrier_id).subscribe((carrier:any)=>{     
      if(carrier.transport_assoc_id != null && carrier.transport_assoc_id != undefined && carrier.transport_assoc_id != 0)
      {
        this.transportAssocService.getById(carrier.transport_assoc_id).subscribe(assoc=>{
          this.tranportAssociation = assoc;
        });
      }
      
    });
  }
 

  initForm() {
    this.form = this.formBuilder.group({
      id: [0, []],
      // startRoute: ['', [<any>Validators.required]],
      // endRoute: ['', [<any>Validators.required]],
      // startPlace: ['', [<any>Validators.required]],
      // endPlace: ['', [<any>Validators.required]],
      btnRadio: ['', [<any>Validators.required]],
      route_name: [null, [<any>Validators.required]],
      code: ['', [<any>Validators.required]],
      route_detail: ['', [<any>Validators.required]],
      route_summary: ['', [<any>Validators.required]],
      description: ['', [<any>Validators.required]],
      transport_assoc: [''],
      // num_countries: ['', [<any>Validators.required]],
      // num_border_crossings: ['', [<any>Validators.required]],
      // desc: ['', [<any>Validators.required]],
    });
  }
  formatter = (x: {name: string}) => x.name;

  // search = (text$: Observable<string>) =>
  // text$.pipe(
  //   debounceTime(200),
  //   distinctUntilChanged(),
  //   merge(this.focus$),
  //   merge(this.click$.pipe(filter(() => !this.instance.isPopupOpen()))),
  //   map(term => (term === '' ? this.places
  //     : this.places.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
  // );
  getSelectedEnd(event)
{
  let country = this.countries.find(x => x.desc == event.item)
  let obj = this.places.find(x => x.country_id == country.id);
  let id = obj.id;
  //console.log(id);
  this.end = id;

}
getSelectedStart(event)
{
  
  let country = this.countries.find(x => x.desc == event.item)
  let obj = this.places.find(x => x.country_id == country.id);
  let id = obj.id;
  this.start = id;
  //console.log(id);

} 
 search = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term === '' ? this.countries.map(v => v.desc)
      : this.countries.map(v => v.desc).filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)),);
      //desc
search2 = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? this.routes.map(v => v.route_detail)
        : this.routes.map(v => v.route_detail).filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)),);


  getSelectedR(event){
    //console.log(event.item);
    let obj = this.routes.find(x => x.route_detail === event.item);
    //console.log(obj);
    this.loadDataFromDatabase(obj);
  }
  checked(){
      //console.log(this.selectedRoute);
      this.default = '';
      this.routeService.getMyRoute(this.selectedRoute.id).subscribe((data:any) =>{
        //console.log(data)
        //this.seele = data.description;
       // this.getOption1Leg(this.selectedRoute.id);
       
        this.loadDataWhenSelected(data);

      })
    
  }
  checkedStartRoute(){
    //console.log(this.selectedStartCoutry)
    this.placeSelected = null;
    //console.log(this.places.filter(x=>x.country_id == this.selectedStartCoutry.id))
    this.placeSelected = this.places.filter(x=>x.country_id == this.selectedStartCoutry.id);
  }
  checkedEndRoute(){
    //console.log(this.selectedEndCoutry)
    this.placeEndSelected = null;
    //console.log(this.places.filter(x=>x.country_id == this.selectedEndCoutry.id))
    this.placeEndSelected = this.places.filter(x=>x.country_id == this.selectedEndCoutry.id);
  }
  getPlaces(){
    this.routeService.getAllRoute().subscribe(data =>{
      //console.log(data);
      this.routes = data;
     //  //console.log(this.routes.map(v => v.route_detail));
    });
    // this.placeService.getPlaces().subscribe(x =>{
    //  //   //console.log(x);
    //   this.places= x
    //   //console.log(this.places)
     
    // //  this.countryService.listCountries().subscribe(data =>{
    // //   this.countries = data;
    // //   //console.log(this.countries);
    // // });
   
    //  });
     
    
  }
  getCustomRoute(){
    this.pageload = true;
   
          this.routeService.getDoNotBelong().subscribe((data:any) =>{
           // alert(this.frghtPass);
           this.ownRoutes = [];
            let tmpRoutes = data.filter(route => route.is_active && route.group_code == this.frghtPass);
            
            tmpRoutes.forEach(element => {
              if(this.ownRoutes.find(r=>r.description == element.description) == null)
              {
                this.ownRoutes.push(element);
              }
            });

            this.selectedRoute = this.ownRoutes.find(x=>x.id == this.dataCntrl.route_id);
           
            // this.isCheck = true;
            // this.checkDelete = true;
         
            this.route_detail = this.dataCntrl.route_detail;
           this.form.patchValue({
           //  id:this.selectedRoute.id, 
            // route_name: this.dataCntrl.route_summary,
            //code:route.code,
            route_detail:this.dataCntrl.route_detail,
            route_summary: this.dataCntrl.route_summary,
            description: this.dataCntrl.route_summary, 
            // num_countries: route.num_countries,
            // num_border_crossings: route.num_border_crossings,
                                   
                                    
          });

          this.pageload = false;
          //alert(this.pageload);
        });
       
    
    if(this.dataCntrl.route_id == null){
      
      this.routeService.getDoNotBelong().subscribe((data:any) =>{
        //console.log(data);
        this.ownRoutes = data.filter(route => route.group_code == this.frghtPass);
        this.pageload = false;
      });
      this.selectedRoute  = 'Select route';
      // this.checkDelete = false;
    }
      
    
    
  }
  checkOption(event){
     //console.log(event.target.value)
     if(event.target.value === '2'){
      this.isCheck = true;
      //  this.routes = null;
      //  this.defaultValue = '';
      
      this.form.patchValue({
        id:'',
       // route_name:'',
        route_detail:'',
        route_summary:'',
        code:'',
        description:'',
        // num_countries:'',
        // num_border_crossings: '',
                               
                                
      });
      this.getCustomRoute();
       
     }
     if(event.target.value === '1'){
      // this.form.reset();
      this.isCheck = false;
      this.checkDelete = false;

      this.getPlaces();
      this.defaultValue = '';
      this.form.patchValue({
        id:'',
        //route_name:'Select route',
        route_detail:'',
        route_summary:'',
        code:'',
        description:'',
        // num_countries:'',
        // num_border_crossings: '',
                               
                                
      });
      this.selectedRoute  = 'Select route';

      // this.form.patchValue({
      //   endRoute: '',
      //   startRoute:'',
                                 
      //  });
      //  this.form.patchValue({
      //   startPlace: '',
      //   endPlace:''
                                 
      //  });
     // this.getPlaces();
  //     this.defaultStartCoutry = 'Select country';
  //     this.defaultEndCoutry = 'Select country';
  //     this.selectedStartCoutry = 'Select country';
  //     this.selectedEndCoutry = 'Select country';

  //     this.selectedEndPlace = 'Select place';
  //   this.selectedStartPlace = 'Select place';
  //  this.defaultStartPlace = 'Select place';
  //  this.defaultEndPlace = 'Select place';

    }
    if(event.target.value === '3'){
     // this.form.reset();
     this.isCheck = false;
     this.checkDelete = false;
     this.getPlaces();
     this.defaultValue = '';

     this.form.patchValue({
      id:'',
     // route_name:'',
      route_detail:'',
      route_summary:'',
      code:'',
      description:'',
      transport_assoc: ''
      // num_countries:'',
      // num_border_crossings: '',
                             
                              
    });
    //   this.getPlaces();
    //   this.defaultStartCoutry = 'Select country';
    //    this.defaultEndCoutry = 'Select country';
    //    this.selectedStartCoutry = 'Select country';
    //    this.selectedEndCoutry = 'Select country';

    //    this.selectedEndPlace = 'Select place';
    //  this.selectedStartPlace = 'Select place';
    // this.defaultStartPlace = 'Select place';
    // this.defaultEndPlace = 'Select place';
    }
   //  this.defaultValue = 'Select route';
  }
  loadDataWhenSelected(route: any) {
    this.form.patchValue({
       id:route.id,
      //route_name : route.description,
      route_detail:route.route_detail, 
      route_summary: route.route_summary,
      code:route.code,
      description: route.description,
      transport_assoc: this.tranportAssociation
      // num_countries: route.num_countries,
      // num_border_crossings: route.num_border_crossings,
                             
                              
    });
  }
  loadDataFromDatabase(route: any) {
    this.form.patchValue({
      // id:route.id,
     // route_name:this.dataCntrl.route_summary,
      code:route.code,
      route_detail:route.route_detail,
      route_summary: route.route_summary,
      description: route.description,
      transport_assoc: this.tranportAssociation
      // num_countries: route.num_countries,
      // num_border_crossings: route.num_border_crossings,
                             
                              
    });
  }
  formChanges(){
    this.form.statusChanges.subscribe(
      result => 
        this.dataCntrl.formValid = result == 'VALID'? true : false 
  );
  }

  updateRouteForApproval()
  {
    this.dataCntrl.route_id = this.selectedRoute.id;
    this.dataCntrl.route_summary = this.form.value.description;
      this.dataCntrl.route_detail = this.form.value.route_detail;

      this.applicationService.putApplication(this.dataCntrl)
      .subscribe(result => {
        this.pageload = false;
        this.dataCntrl = result;
        this.tabload = false;
       // this.saveDepatureDestination();
       this.toastService.success('Update Route Details','Route details updated successfully');
       
        },
        error => {
          this.pageload = false;
          this.tabload = false;
          this.toastService.error('Failed to update route details. If the problem persist, please contact system administrator.','Save Application')

        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
        });
  }

  saveRoute(){
   //console.log(this.form.value.description);
    if(!this.form.value.description){
      return this.toastService.error ('Please Enter a name for the route that is easy to remember (e.g. Harare to Joburg)"','Route Details');
    }
    if(!this.form.value.route_summary){
      return this.toastService.error('Please Enter a short description of the route (e.g. Harare to Joburg via Bulawayo)"','Route Details');
    }
    if(!this.form.value.code){
      return this.toastService.error('Please Enter a unique identifier for this route (e.g. HREJHB01)', 'Route Details');
    }
    
    if(!this.form.value.route_detail){
      return this.toastService.error('Enter a detailed description of the whole route, indicating all the stopping points and border posts','Route Details');
    }
    // if(this.form.value.endPlace === 'Select place'){
    //   return this.toastr.warning('Please choose your end place route');
    // }
    
    // if(this.form.value.btnRadio === '3'){
    //    this.saveDepatureDestination();
    //    return 
    // }
   
  
    let route = {
       id:0,
       code:this.form.value.code+'-'+this.dataCntrl.id,
      route_detail: this.form.value.route_detail,
      description: this.form.value.description,
      route_summary: this.form.value.route_summary,
      // num_countries:this.form.value.num_countries,
      // num_border_crossings:this.form.value.num_border_crossings,
      user_created:  environment.authWebApi.userData.User.FirstName,
      user_modified: environment.authWebApi.userData.User.FirstName,
      date_created: new Date(),
      date_modified:new Date(),
    }
    if(this.form.value.btnRadio === '2'){
      
      route = {
        id:this.form.value.id,
        code:this.form.value.code,
        route_detail: this.form.value.route_detail,
        description: this.form.value.description,
        route_summary: this.form.value.route_summary,
        // num_countries:this.form.value.num_countries,
        // num_border_crossings:this.form.value.num_border_crossings,
        user_created:  environment.authWebApi.userData.User.FirstName,
        user_modified:environment.authWebApi.userData.User.FirstName,
        date_created: new Date(),
        date_modified:new Date(),
      }
    }
    //console.log(route)
    if(route.code.length > 12){
      route.code = route.code.substr(0,12)
    }
    this.tabload = true;
    this.pageload = true;
     this.routeService.saveMyRoutes(route).subscribe((x:any) =>{
      //console.log(x);
      this.updatePermit(x.id)
      this.dataCntrl.route_id = x.id;
      this.dataCntrl.route_summary = this.form.value.description;
      this.dataCntrl.route_detail = this.form.value.route_detail;

      this.applicationService.putApplication(this.dataCntrl)
      .subscribe(result => {
        this.pageload = false;
        this.dataCntrl = result;
        this.tabload = false;
       // this.saveDepatureDestination();
       this.toastService.success('Save Application','Route saved successfully');
        this.applicationService.setTab(4);
        },
        error => {
          this.pageload = false;
          this.tabload = false;
          this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Save Application')

        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
        });
    
     },
     error => {
       //console.log(error.error.Message)
       if(error.error.Message === 'Code already exists'){
        this.pageload = false;
        this.tabload = false;
        this.toastService.error('Code already exists! Choose a different code.','Save Application')
         return;
       }
       this.pageload = false;
       this.tabload = false;
       this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Save Application')

     // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
     return;
     });
    
  }

saveDepatureDestination(){
  // if(this.form.value.btnRadio === '3'){
  //   return this.saveBtn3();
  // }
 
  let obj = {
    id:0,
    place_to_id: this.form.value.endPlace.id,
    place_from_id: this.form.value.startPlace.id,
    route_description:this.form.value.description,
    application_id: +this.dataCntrl.id,
    permit_id:this.dataCntrl.permit.id,
    route_id:this.form.value.id,
    place_to: this.form.value.endRoute.desc,
    place_from:this.form.value.startRoute.desc,
    date_created: new Date(),
    date_modified:new Date(),
  }
  

 if(this.form.value.btnRadio === '2' || this.form.value.btnRadio === '1'){
  if(obj.place_to_id == undefined){
    obj.place_to_id = this.end;
    // obj.place_from_id = this.start;
   }
   if(obj.place_from_id == undefined){
    // obj.place_to_id = this.end;
    obj.place_from_id = this.start;
   }
   if(this.form.value.endRoute.desc){
    this.form.value.endRoute = this.form.value.endRoute.desc
   }
   if(this.form.value.startRoute.desc){
    this.form.value.startRoute = this.form.value.startRoute.desc;
   }
  obj.place_to = this.form.value.endRoute;
  obj.place_from = this.form.value.startRoute
}
  //console.log(obj);
  //console.log(this.form.value);
      this.pageload = true;
      this.tabload = true;

  this.routeService.saveRouteLeg(obj).subscribe(x =>{
    this.pageload = false;
    this.tabload = false;
    this.toastService.success('Save Application','Route saved successfully');

        this.applicationService.setTab(4);

  },error =>{
    this.pageload = false;
    this.tabload = false;
    this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Save Application')

  })
}
saveBtn3(){
  let obj = {
     id:0,
     place_to_id: this.form.value.endPlace.id,
     place_from_id: this.form.value.startPlace.id,
     route_description:this.form.value.description,
     application_id: +this.dataCntrl.id,
     permit_id:this.dataCntrl.permit.id,
     place_to: this.form.value.endRoute.desc,
     place_from:this.form.value.startRoute.desc,
     date_created: new Date(),
     date_modified:new Date(),
   }
   this.pageload = true;
   this.tabload = true;
   this.routeService.saveRouteLeg(obj).subscribe(x =>{
    this.pageload = false;
    this.tabload = false;
    this.toastService.success('Save Application','Route saved successfully');

        this.applicationService.setTab(4);

  },error =>{
    this.pageload = false;
    this.tabload = false;
    this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Save Application')

  })
}
savePermit(){
      
  this.dataCntrl.permit.date_modified = this.dataCntrl.permit.date_created = new Date();
  this.dataCntrl.permit.user_modified = this.dataCntrl.permit.user_created =  environment.authWebApi.userData.User.FirstName;
  this.dataCntrl.permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee ;
  this.dataCntrl.permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee ;
  this.permitService.postPermit(this.dataCntrl.permit)
  .subscribe(result => {
    this.dataCntrl.permit = result;
    this.tabload = false;
    this.toastService.success('Saved Permit Type Successfully','Permit Type');
    // this.applicationService.setTab(2);
  },
    error => {
      this.tabload = false
      this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.', error)

      return;
    });
}
updatePermit(id){
  this.dataCntrl.permit.route_id = id;
  this.dataCntrl.permit.date_modified  = this.dataCntrl.permit.date_created = new Date();
  this.dataCntrl.permit.user_modified = this.dataCntrl.permit.user_created =  environment.authWebApi.userData.User.FirstName;
  this.dataCntrl.permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee ;
  this.dataCntrl.permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee ;
  this.permitService.upadatePermit(this.dataCntrl.permit).subscribe(result => {
    this.dataCntrl.permit = result;
   // this.toastr.success('Updated Permit Type Successfully','Permit Type');
   // this.applicationService.setTab(2);

  })

}

  backtoVehicle(){
    this.applicationService.setTab(2);
  }
  deleteRoute(){
    this.showModal.showConfirm('Delete Route', 'Are you sure you want to delete?', `You're about to delete this route`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.delete(this.dataCntrl.route_id);
        } else {
          return;
        }
      });
  }
  delete(id){
    this.routeService.deleteExternalRoute(id).subscribe((x:any) =>{
      this.routeService.getDoNotBelong();
      this.dataCntrl.route_id = null;
      //console.log(x);
      this.checkDelete = false;
      this.isCheck = false;
      this.toastService.success('Delete Route','Route deleted successfully');
     },
     error => {
       //console.log(error.error.Message)
       this.toastService.error('Failed to save application. If the problem persist, please contact system administrator.','Save Application')
     // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
     return;
     });
  }
  onSubmit(value){
//console.log(value)
  }
  cancelApplication(){
    if(this.dataCntrl.id==undefined && this.dataCntrl.id==null){
      this.router.navigate(['/carrier/permit/application/'+this.dataCntrl.carrierID]);
    }else{
      this.showModal.showConfirm('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.deleteApplication()
        } else {
          return;
        }
      });
    }
  }
  deleteApplication(){
    //console.log("delete application");
    this.pageload = true;

    this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x =>{
      //console.log(x);
    this.deleteApp(this.dataCntrl.id);
    this.pageload = false;

    this.router.navigate(['/carrier/permit/application/'+this.dataCntrl.carrierID]);

    })
//this.dataCntrl.id
//this.dataCntrl.permit.id
  }
  deletePermit(id){
    this.permitService.deletePermit(id).subscribe(x =>{
      //console.log(x);
    })

  }
  deleteApp(id){
    this.applicationService.deleteApplication(id).subscribe(x =>{
      //console.log(x);
    })
  }
  getOption1Leg(id){
    this.placeService.getPlaces().subscribe((q:any) =>{
      this.routeService.getAllRouteLegs().subscribe((x:any) =>{
        //console.log(x.filter(x =>x.route_id === id));
        let obj = x.filter(x =>x.route_id === id);
        //console.log(Math.max.apply(Math, obj.map(function(o) { return o.id; })))
        let foundRouteLeg = obj.find(x => x.id == Math.max.apply(Math, obj.map(function(o) { return o.id; })));
        let routeLegFromPlace = q.find(x => x.id == foundRouteLeg.place_from_id);
        let routeLeToPlace = q.find(x => x.id == foundRouteLeg.place_to_id);
        
        //console.log(foundRouteLeg.place_from)
        //console.log(foundRouteLeg.place_to)
        this.loadRouteLeg(foundRouteLeg)
        this.end = routeLeToPlace.id;
        this.start =  routeLegFromPlace.id;

        //console.log(routeLegFromPlace.name);
        //console.log(routeLeToPlace.name);
        this.loadRouteLegPlaces(routeLegFromPlace.name,routeLeToPlace.name);
        
      })

      });
  }
  getAllRouteLegs(){
    let accumulateCoutries:any = [];
    this.placeService.getPlaces().subscribe((q:any) =>{
      this.routeService.getAllRouteLegs().subscribe((x:any) =>{
        //console.log(x.filter(x =>x.application_id === +this.dataCntrl.id));
        let obj = x.filter(x =>x.application_id === +this.dataCntrl.id);
        //console.log(Math.max.apply(Math, obj.map(function(o) { return o.id; })))
        let foundRouteLeg = obj.find(x => x.id == Math.max.apply(Math, obj.map(function(o) { return o.id; })));
        let routeLegFromPlace = q.find(x => x.id == foundRouteLeg.place_from_id);
        let routeLeToPlace = q.find(x => x.id == foundRouteLeg.place_to_id);
        
        //console.log(foundRouteLeg.place_from)
        //console.log(foundRouteLeg.place_to)
        this.loadRouteLeg(foundRouteLeg)
        this.end = routeLeToPlace.id;
        this.start =  routeLegFromPlace.id;

        //console.log(routeLegFromPlace.name);
        //console.log(routeLeToPlace.name);
        this.loadRouteLegPlaces(routeLegFromPlace.name,routeLeToPlace.name);
        // for(var i = 0;i<obj.length;i++){
        //   for(var j =0;j<q.length;j++){
        //     if(obj[i].place_from_id === q[j].id){
        //       //console.log(q[j].id)//country_id
        //       //console.log(q[j].country_id)
        //       //console.log(this.countries.find(x => x.id == q[j].country_id));
        //       //console.log(this.countries.filter(x => x.id == q[j].country_id))
        //       accumulateCoutries.push(this.countries.find(x => x.id == q[j].country_id))
        //     }
        //   }
         

        // }
        //  //console.log(accumulateCoutries)
        //  this.countries = accumulateCoutries;
        //  //console.log(this.countries);
        // //console.log(obj.map(x =>x.country_id))
        // //console.log(this.countries.filter(x => x.id == obj.map(x =>x.country_id)[0]))
        // this.countries.filter(x => x.id == obj.map(x =>x.country_id)[0])
        // if(obj.length >0 ){
        //    for(let i=0;i<obj.length;i++){
        //      //console.log(obj[i])
        //     // this.loadRouteLeg(obj[i]);
        //    }
        // }
      })

      });
    
  }
  loadRouteLeg(data){
    this.form.patchValue({
     endRoute: data.place_to,
     startRoute:data.place_from,
                              
    });
    this.defaultStartCoutry = data.place_from;
    this.defaultEndCoutry = data.place_to;
  }
  loadRouteLegPlaces(start,end){
    this.form.patchValue({
     startPlace: start,
     endPlace:end,
                              
    });
    this.defaultStartPlace = start;
    this.defaultEndPlace = end;
  }
}
